import { generatePath } from '@cibo/core'
import ChevronRightRounded from '@mui/icons-material/ChevronRightRounded'
import { Box, Button } from '@mui/material'
import { LayoutSection } from 'components/ImpactLayout'
import { ADMIN_ROUTES } from 'navigation/types'
import { useTranslation } from 'react-i18next'
import { Link, useNavigate } from 'react-router-dom'
import { FDRRollups } from '../FDRRollups'
import { ProgramsTable } from './ProgramsTable'

export const ProgramList = () => {
  const { t } = useTranslation('impact/pages/Admin/Programs/ProgramList')
  const navigate = useNavigate()
  return (
    <LayoutSection>
      <FDRRollups />
      <Box>
        <Button
          variant="outlined"
          component={Link}
          to={ADMIN_ROUTES.ENROLLED_FIELDS_MAP}
          endIcon={<ChevronRightRounded />}
          size="small"
          data-testid="enrolledFieldsMapBtn"
        >
          {t('enrolledFieldsMap')}
        </Button>
      </Box>
      <ProgramsTable
        onRowClick={({ id }) => {
          navigate(generatePath(ADMIN_ROUTES.PROGRAM_DETAIL, { programId: id as string }))
        }}
      />
    </LayoutSection>
  )
}
